/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_home_season_concluded = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Season ${i?.season} has concluded`)
};

const es_f1_home_season_concluded = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La temporada ${i?.season} ha concluido`)
};

const de_f1_home_season_concluded = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Saison ${i?.season} ist beendet`)
};

const nl_f1_home_season_concluded = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seizoen ${i?.season} is afgelopen`)
};

const fr_f1_home_season_concluded = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La saison ${i?.season} est terminée`)
};

const it_f1_home_season_concluded = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La stagione ${i?.season} è conclusa`)
};

const pt_br2_f1_home_season_concluded = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A temporada ${i?.season} encerrou`)
};

const pt_f1_home_season_concluded = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A época ${i?.season} terminou`)
};

const ja_f1_home_season_concluded = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.season}シーズンは終了しました`)
};

const zh_f1_home_season_concluded = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.season}赛季已结束`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ season: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_home_season_concluded = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_home_season_concluded(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_home_season_concluded", locale)
	if (locale === "en") return en_f1_home_season_concluded(inputs)
	if (locale === "es") return es_f1_home_season_concluded(inputs)
	if (locale === "de") return de_f1_home_season_concluded(inputs)
	if (locale === "nl") return nl_f1_home_season_concluded(inputs)
	if (locale === "fr") return fr_f1_home_season_concluded(inputs)
	if (locale === "it") return it_f1_home_season_concluded(inputs)
	if (locale === "pt-BR") return pt_br2_f1_home_season_concluded(inputs)
	if (locale === "pt") return pt_f1_home_season_concluded(inputs)
	if (locale === "ja") return ja_f1_home_season_concluded(inputs)
	return zh_f1_home_season_concluded(inputs)
};